/** CoStar.Api.ListingUser.ViewModels.Campaign.Enums.CampaignReferenceInfoType */
export var CampaignReferenceInfoType;
(function (CampaignReferenceInfoType) {
    CampaignReferenceInfoType[CampaignReferenceInfoType["None"] = 0] = "None";
    CampaignReferenceInfoType[CampaignReferenceInfoType["LegacyListingPushId"] = 1] = "LegacyListingPushId";
    CampaignReferenceInfoType[CampaignReferenceInfoType["CampaignSenderIP"] = 2] = "CampaignSenderIP";
    CampaignReferenceInfoType[CampaignReferenceInfoType["CampaignSenderUserAgent"] = 3] = "CampaignSenderUserAgent";
    CampaignReferenceInfoType[CampaignReferenceInfoType["SavedSearchId"] = 4] = "SavedSearchId";
    CampaignReferenceInfoType[CampaignReferenceInfoType["CdxCampaignId"] = 5] = "CdxCampaignId";
})(CampaignReferenceInfoType || (CampaignReferenceInfoType = {}));
/** CoStar.Api.ListingUser.ViewModels.Campaign.Enums.CampaignEntityType */
export var CampaignEntityType;
(function (CampaignEntityType) {
    CampaignEntityType[CampaignEntityType["None"] = 0] = "None";
    CampaignEntityType[CampaignEntityType["CommercialListing"] = 1] = "CommercialListing";
})(CampaignEntityType || (CampaignEntityType = {}));
/** CoStar.Api.ListingUser.ViewModels.Campaign.Enums.CampaignType */
export var CampaignType;
(function (CampaignType) {
    CampaignType[CampaignType["None"] = 0] = "None";
    CampaignType[CampaignType["ListingProspect"] = 1] = "ListingProspect";
    CampaignType[CampaignType["ListingProspectForPriceChange"] = 2] = "ListingProspectForPriceChange";
})(CampaignType || (CampaignType = {}));
/** CoStar.Api.ListingUser.ViewModels.Campaign.Enums.CampaignStatus */
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus[CampaignStatus["None"] = 0] = "None";
    CampaignStatus[CampaignStatus["DraftCreatedByTheSender"] = 1] = "DraftCreatedByTheSender";
    CampaignStatus[CampaignStatus["SubmittedByTheSender"] = 2] = "SubmittedByTheSender";
    CampaignStatus[CampaignStatus["FulfillmentStarted"] = 3] = "FulfillmentStarted";
    CampaignStatus[CampaignStatus["FulfillmentCompleted"] = 4] = "FulfillmentCompleted";
    CampaignStatus[CampaignStatus["NotProcessedDueToEntityDetailsNotFound"] = 5] = "NotProcessedDueToEntityDetailsNotFound";
    CampaignStatus[CampaignStatus["ErrorOccurredWhileProcessingTheCampaign"] = 6] = "ErrorOccurredWhileProcessingTheCampaign";
    CampaignStatus[CampaignStatus["RecipientNotYetProcessed"] = 7] = "RecipientNotYetProcessed";
    CampaignStatus[CampaignStatus["RecipientProcessedAndEmailSubmittedToTheDeliveryProvider"] = 8] = "RecipientProcessedAndEmailSubmittedToTheDeliveryProvider";
    CampaignStatus[CampaignStatus["EmailDeliveredToTheRecipient"] = 9] = "EmailDeliveredToTheRecipient";
    CampaignStatus[CampaignStatus["InvalidOrIncompleteRecipientInformation"] = 10] = "InvalidOrIncompleteRecipientInformation";
    CampaignStatus[CampaignStatus["ErrorOccurredWhileProcessingTheRecipient"] = 11] = "ErrorOccurredWhileProcessingTheRecipient";
    CampaignStatus[CampaignStatus["NotDeliveredDueToRecipientListIsEmptyOrBlocked"] = 12] = "NotDeliveredDueToRecipientListIsEmptyOrBlocked";
    CampaignStatus[CampaignStatus["NotDeliveredDueToSenderIsBlocked"] = 13] = "NotDeliveredDueToSenderIsBlocked";
    CampaignStatus[CampaignStatus["ErrorOccurredWhileProcessingTheEmailByDeliveryProvider"] = 14] = "ErrorOccurredWhileProcessingTheEmailByDeliveryProvider";
    CampaignStatus[CampaignStatus["InvalidOrIncompleteCampaignRequest"] = 15] = "InvalidOrIncompleteCampaignRequest";
})(CampaignStatus || (CampaignStatus = {}));
/** CoStar.Api.ListingUser.ViewModels.Campaign.Enums.CampaignActionType */
export var CampaignActionType;
(function (CampaignActionType) {
    CampaignActionType[CampaignActionType["None"] = 0] = "None";
    CampaignActionType[CampaignActionType["ReadOnWeb"] = 1] = "ReadOnWeb";
    CampaignActionType[CampaignActionType["ReadOnEmail"] = 2] = "ReadOnEmail";
    CampaignActionType[CampaignActionType["ReadOnApp"] = 3] = "ReadOnApp";
    CampaignActionType[CampaignActionType["MarkedAsSpam"] = 4] = "MarkedAsSpam";
    CampaignActionType[CampaignActionType["MarkedAsNotSpam"] = 5] = "MarkedAsNotSpam";
    CampaignActionType[CampaignActionType["Activate"] = 6] = "Activate";
    CampaignActionType[CampaignActionType["Deactivate"] = 7] = "Deactivate";
})(CampaignActionType || (CampaignActionType = {}));
